import {IS_PROD} from '@/constants/env'

const initVConsole = () => {
    if (!IS_PROD && !location.href.includes('localhost')) {
        console.log(`APP_ENV: ${process.env.APP_ENV}`)
        // console.log(`NEXT_PUBLIC_API_BASE_URL: ${process.env.NEXT_PUBLIC_API_BASE_URL}`);
        // console.info('当前页面 url', window.location.href);
        const eruda = require('eruda')
        eruda.init()
        // 刷新按钮
        if (!document.querySelector('.vRefreshButton')) {
            const vRefreshButton = document.createElement('div')
            vRefreshButton.className = 'vRefreshButton'
            vRefreshButton.innerHTML = '<?xml version="1.0" encoding="UTF-8"?><svg width="25" height="25" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42 8V24" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 24L6 40" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M42 24C42 14.0589 33.9411 6 24 6C18.9145 6 14.3216 8.10896 11.0481 11.5M6 24C6 33.9411 14.0589 42 24 42C28.8556 42 33.2622 40.0774 36.5 36.9519" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            vRefreshButton.addEventListener('click', () => {
                location.reload()
            })
            document.firstElementChild?.appendChild(vRefreshButton)
        }
    }
}

export default initVConsole
